import axios from 'axios'

// csrfトークンを自動更新（Railsの設定に合わせる）
axios.defaults.withCredentials = true

// NOTE !!!!!!! バックエンドへの回送用URLを環境で返られるようにすべし !!!!!!!!!
let httpClient = axios.create({
  withCredentials: true,
  credentials: 'include',
  // baseURL: process.env.VUE_APP_BASE_URL
})

// CSRFトークンをキャッシュする変数
let cachedCsrfToken = null
let csrfTokenPromise = null

// CSRFトークンを取得する関数（キャッシュ付き）
// 重要: 同じhttpClientインスタンスを使用してセッションの一貫性を保つ
const fetchCsrfToken = () => {
  // 既にトークンがある場合はそれを返す
  if (cachedCsrfToken) {
    return Promise.resolve(cachedCsrfToken)
  }
  
  // 既にリクエスト中の場合はそのPromiseを返す
  if (csrfTokenPromise) {
    return csrfTokenPromise
  }
  
  // 新しいトークンを取得（httpClientを使用してセッションを維持）
  csrfTokenPromise = httpClient.get('/api/sessions', { withCredentials: true })
    .then(res => {
      const token = res.headers['x-csrf-token']
      if (token) {
        cachedCsrfToken = token
        console.log('CSRF token cached:', token.substring(0, 20) + '...')
      }
      csrfTokenPromise = null
      return token
    })
    .catch(error => {
      console.error('Failed to fetch CSRF token:', error)
      csrfTokenPromise = null
      throw error
    })
  
  return csrfTokenPromise
}

// レスポンスインターセプター: 新しいCSRFトークンを自動更新
httpClient.interceptors.response.use(
  (response) => {
    // レスポンスヘッダーに新しいCSRFトークンがある場合は更新
    const newToken = response.headers['x-csrf-token']
    if (newToken && newToken !== cachedCsrfToken) {
      cachedCsrfToken = newToken
      console.log('CSRF token updated from response')
    }
    return response
  },
  async (error) => {
    const originalRequest = error.config
    
    // CSRF検証エラーの場合、トークンをクリアして再試行
    if (error.response && error.response.status === 400 && 
        error.response.data && error.response.data.message === 'bad csrf token.' &&
        !originalRequest._retry) {
      
      console.warn('CSRF token validation failed, retrying with new token...')
      originalRequest._retry = true
      cachedCsrfToken = null // キャッシュをクリア
      
      try {
        const token = await fetchCsrfToken()
        originalRequest.headers['X-CSRF-TOKEN'] = token
        return httpClient(originalRequest)
      } catch (retryError) {
        return Promise.reject(retryError)
      }
    }
    
    return Promise.reject(error)
  }
)

export default {
  httpClient,

  // 既存のコードとの互換性のため
  // 重要: axios.create()ではなくhttpClientを使用することでセッションの一貫性を保つ
  currentCsrfToken () {
    return fetchCsrfToken()
  },
  
  // CSRFトークンのキャッシュをクリア（必要に応じて使用）
  clearCsrfToken () {
    cachedCsrfToken = null
    console.log('CSRF token cache cleared')
  }
}
